import cipher23Image1 from '../../../assets/images/games/zdar-escape-game/ciphers/23/image1.webp';
import cipher23Image2 from '../../../assets/images/games/zdar-escape-game/ciphers/23/image2.webp';
import cipher23Image3 from '../../../assets/images/games/zdar-escape-game/ciphers/23/image3.webp';
import cipher23Image4 from '../../../assets/images/games/zdar-escape-game/ciphers/23/image4.webp';
import cipher23Image5 from '../../../assets/images/games/zdar-escape-game/ciphers/23/image5.webp';
import cipher23Image6 from '../../../assets/images/games/zdar-escape-game/ciphers/23/image6.webp';
import cipher23Image7 from '../../../assets/images/games/zdar-escape-game/ciphers/23/image7.webp';

export const zdarEscapeGameCipher23Images = [
    cipher23Image1,
    cipher23Image2,
    cipher23Image3,
    cipher23Image4,
    cipher23Image5,
    cipher23Image6,
    cipher23Image7,
];
